













import { Component, Prop, Vue } from "vue-property-decorator";
import { IFiltersOptions } from "@/models/tables";

@Component
export default class SelectRadioFilter extends Vue {
  @Prop({ required: true })
  public value!: any;

  @Prop({ default: () => [] })
  public options!: IFiltersOptions[];

  @Prop({ default: false })
  public disabled!: boolean;

  public get label() {
    const value = this.$_.toNumber(this.value);
    const optionIndex = this.$_.findIndex(
      this.options || [],
      (option: IFiltersOptions) => this.$_.toNumber(option.value) === value
    );
    if (optionIndex === -1) return this.$t(value ? "_.yes" : "_.no");
    const label = this.options[optionIndex].label as string;
    return label.startsWith("_") ? this.$t(label) : label;
  }
}
